import { useSurfacePreferenceProperty } from "@/components/preferences/usePreferences.tsx";

/**
 * Whether a plain-Enter submit that starts a new thread keeps the user where
 * they are (confirmation toast) instead of opening the new thread.
 * Cmd/Ctrl+Enter always does the opposite.
 */
export const useSendInBackgroundEnabled = (): boolean =>
  useSurfacePreferenceProperty("global", "sendInBackground");
